import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AudioVideoIcon, CCTVIcon, AutomationIcon, SoftwareIcon, PhoneIcon } from './Icons';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  // Determine which section we're in
  const isDigitalSection = location.pathname.startsWith('/digital') || location.pathname.startsWith('/apps');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  }, [location]);

  const avServices = [
    { key: 'audio-video', name: 'Audio/Video Systems', Icon: AudioVideoIcon },
    { key: 'cctv', name: 'CCTV & Security', Icon: CCTVIcon },
    { key: 'automation', name: 'Smart Automation', Icon: AutomationIcon },
  ];

  const digitalServices = [
    { key: 'software', name: 'Software Development', Icon: SoftwareIcon },
  ];

  const services = isDigitalSection ? digitalServices : avServices;

  return (
    <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="SVT Consulting" className="logo-image" />
        </Link>

        <nav className={`navbar-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          {isDigitalSection ? (
            <>
              <Link to="/digital" className={location.pathname === '/digital' ? 'active' : ''}>Home</Link>
              <Link to="/portfolio" className={location.pathname.startsWith('/portfolio') ? 'active' : ''}>Portfolio</Link>
              <Link to="/apps" className={location.pathname.startsWith('/apps') ? 'active' : ''}>Apps</Link>
              <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link>
              <Link to="/smart-home" className="nav-switch">
                <span className="switch-icon">⟷</span> Smart Home
              </Link>
            </>
          ) : (
            <>
              <Link to="/smart-home" className={location.pathname === '/smart-home' ? 'active' : ''}>Home</Link>
              
              <div 
                className={`nav-dropdown ${activeDropdown === 'services' ? 'active' : ''}`}
                onMouseEnter={() => setActiveDropdown('services')}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <Link to="/services" className={location.pathname.startsWith('/services') ? 'active' : ''}>
                  Services <span className="dropdown-arrow">▼</span>
                </Link>
                <div className="dropdown-menu">
                  <div className="dropdown-content">
                    {services.map(service => (
                      <Link key={service.key} to={`/services/${service.key}`} className="dropdown-item">
                        <span className="dropdown-icon">
                          <service.Icon size={28} color="#FF5722" />
                        </span>
                        <span>{service.name}</span>
                      </Link>
                    ))}
                    <div className="dropdown-footer">
                      <Link to="/services" className="view-all">View All Services →</Link>
                    </div>
                  </div>
                </div>
              </div>

              <Link to="/portfolio" className={location.pathname.startsWith('/portfolio') ? 'active' : ''}>Portfolio</Link>
              <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link>
              <Link to="/digital" className="nav-switch">
                <span className="switch-icon">⟷</span> Digital
              </Link>
            </>
          )}
        </nav>

        <div className="navbar-actions">
          <a href="tel:+18453043934" className="navbar-phone">
            <PhoneIcon size={18} color="#FF5722" />
            <span className="phone-text">Call Us</span>
          </a>
          <Link to="/contact" className="btn btn-primary navbar-cta">Get Quote</Link>
        </div>

        <button 
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
